export default __webpack_public_path__ + "static/media/cover_bubbleshooter.d515fada.mp4";